import { observer } from 'mobx-react-lite';
import type { ReactElement } from 'react';
import {
	ChatAttachmentView,
	ChatDialogEvent,
	ChatDialogEventDirection,
	ChatDialogEventType,
	ChatSystemEventViewWithReason,
} from 'sdk';

import { useSDK } from '../../../../app';
import { AgentMessageContainer } from '../agentMessage';
import { ClientMessage } from '../clientMessage';
import { DialogResolvedMessage } from '../dialogResolvedMessage';
import { SelectionButtons } from '../selectionButtons';
import { SystemMessage } from '../systemMessage';

type Interface = {
	message: ChatDialogEvent;
	hideAvatar: boolean;
};

const Component = ({ message, hideAvatar }: Interface): ReactElement | null => {
	const rootStore = useSDK();

	switch (message.view.type) {
		case ChatDialogEventType.Attach:
		case ChatDialogEventType.Text:
		case ChatDialogEventType.SelectionAnswer: {
			if (
				!message.view.text &&
				(message.view.type !== ChatDialogEventType.Attach || !(message.view as ChatAttachmentView).attachId)
			) {
				return null;
			}
			return (
				<div key={message.id}>
					{ChatDialogEventDirection.FromVisitor === message.direction && <ClientMessage message={message} />}
					{ChatDialogEventDirection.ToVisitor === message.direction && (
						<AgentMessageContainer message={message} hideAvatar={hideAvatar} />
					)}
				</div>
			);
		}

		case ChatDialogEventType.Routing:
		case ChatDialogEventType.Assign:
		case ChatDialogEventType.AgentHandling:
		case ChatDialogEventType.ChatSystem: {
			return (message.view.text && <SystemMessage message={message.view.text} />) || null;
		}

		case ChatDialogEventType.Resolve: {
			return (
				<div key={message.id}>
					<DialogResolvedMessage finisher={(message.view as ChatSystemEventViewWithReason).reason} />
				</div>
			);
		}
		case ChatDialogEventType.Selection: {
			return (
				<div key={message.id}>
					<SelectionButtons
						message={message}
						hideAvatar={hideAvatar}
						showButtons={rootStore.eventsStore.isButtonsShouldBeDisplayed(message)}
					/>
				</div>
			);
		}

		default:
			return null;
	}
};

export const ChatMessagesItem = observer(Component);
